var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSeparator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 25,
    viewBox: "0 0 15 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35661 10.0024L5.88745 12.4972L8.82177 12.4907L7.35661 10.0024Z",
    fill: "#0089CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41435 5.00122L0 12.4923H2.93867L5.88351 7.49596L4.41435 5.00122Z",
    fill: "#0089CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82068 7.484L11.7847 12.4967H14.7093L10.2826 5.00122L8.82068 7.484Z",
    fill: "#FF0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82177 2.48822L7.35661 0L5.88745 2.4951L7.35262 4.98332L8.82177 2.48822Z",
    fill: "#FF0000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35256 14.9976L8.82172 12.5028L5.88739 12.5093L7.35256 14.9976Z",
    fill: "#0089CF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2948 19.9988L14.7092 12.5077H11.7705L8.82566 17.504L10.2948 19.9988Z",
    fill: "#0089CF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88849 17.516L2.92445 12.5033H-9.01222e-05L4.42658 19.9988L5.88849 17.516Z",
    fill: "#FF0000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88739 22.5118L7.35256 25L8.82172 22.5049L7.35655 20.0167L5.88739 22.5118Z",
    fill: "#FF0000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSeparator);
export default __webpack_public_path__ + "static/media/ic_separator.efdb2983494b00dbd5328e4e8e7db9cf.svg";
export { ForwardRef as ReactComponent };